import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55561084"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeaderBanner: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/PageHeaderBanner.vue').default,BreadCrumb: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/BreadCrumb.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default,InquiryForm: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/InquiryForm.vue').default})
